import AdminPage from './pages/AdminPage.svelte'
import EmailPage from './pages/EmailPage.svelte'

export default [
  { path: '/admin', component: AdminPage },
  { path: '/admin/emails', component: EmailPage }
]
